import { config } from '@client/config';
import { sanitizeLanguage } from '@client/i18n/utils/language';
import axios, { AxiosInstance } from 'axios';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

export const getApiClient = (language?: LANGUAGE_CODE): AxiosInstance => {
  const headers = {
    'X-Requested-With': 'XMLHttpRequest',
  };
  if (language) {
    headers['Accept-Language'] = language;
  }

  const client = axios.create({
    withCredentials: true,
    baseURL: config.url.api,
    timeout: 30 * 1000,
    headers,
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const logoutReason = error?.response?.headers?.['x-logout-reason'];
      const isInactivityLogout = logoutReason === 'inactivity';
      const isBrowser = typeof window !== 'undefined';
      const isOnInactivityPage = isBrowser && window.location.pathname.includes('/inactivity-error');

      if (isInactivityLogout && isBrowser && !isOnInactivityPage) {
        const langFromPath = window.location.pathname.split('/')[1];
        const currentLang = language || sanitizeLanguage(langFromPath) || config.languages.default;
        const inactivityErrorUrl = `/${currentLang}/inactivity-error`;

        window.location.href = `/auth/logout?backTo=${encodeURIComponent(inactivityErrorUrl)}`;
      }

      return Promise.reject(error);
    },
  );

  return client;
};
